import { Grid } from '@mui/material';
import axios from 'axios';
import React from 'react';
import { alertRef } from '../../App';
import Modal from '../../Components/Modal/Modal';
import { Button } from '../../Components/StyledComponents';
import { convertCost } from '../../Utils/functions';
import CommerceCouponCreate from './CommerceCouponCreate';
import './CommerceCoupon.scss';
import CommerceCouponInfo from './CommerceCouponInfo';

const couponVariant = {
    '상품증정': '#d8ead3',
    '% 할인': '#ffe6b4',
    '1+1': '#cce0ff',
    '원 할인': '#ffddda'
}

const couponTextVariant = {
    '상품증정': '#3d9822',
    '% 할인': '#ffaa00',
    '1+1': '#0064ff',
    '원 할인': '#f95f53'
}

const CommerceCoupon = () => {
    const [list, setList] = React.useState([]);//커머스 쿠폰 목록
    const [info, setInfo] = React.useState({})//선택한 쿠폰 상세 정보

    const modalRef = React.useRef(null);//쿠폰 상세 모달
    const createModalRef = React.useRef(null);//쿠폰 생성 모달

    React.useEffect(() => {
        getCoupons()
    }, [])

    //커머스 쿠폰 목록 get
    const getCoupons = () => {
        axios.get('/api/commerce/coupon')
            .then((data) => {
                setList(data.data)
            })
    }

    //커머스 쿠폰 생성
    const createCoupon = (name, description, discountRate, originPrice, category, image, isLimit, count) => {
        axios.post('/api/commerce/coupon', {
            Name: name,
            Description: description,
            OriginPrice: Number(originPrice),
            DiscountRate: Number(discountRate),
            Category: category,
            Image: image,
            IsLimit: JSON.parse(isLimit),
            LimitCount: Number(count)
        })
            .then((data) => {
                if (data.status === 204) {
                    createModalRef.current.closeModal();
                    getCoupons()
                    alertRef.current.showAlert({ title: `쿠폰이 발행되었습니다.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    //커머스 쿠폰 삭제
    const deleteCoupon = (id) => {
        axios.delete('/api/commerce/coupon/' + id)
            .then((data) => {
                getCoupons();
                modalRef.current.closeModal();
                alertRef.current.showAlert({ title: `정상적으로 처리 되었습니다.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
            .catch(() => {
                modalRef.current.closeModal();
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    //커머스 쿠폰 삭제 확인
    const deleteCouponAlert = (e, data) => {
        if (e.target.id === 'delete-icon') {
            alertRef.current.showAlert({ title: `정말 쿠폰을 삭제하시겠어요?`, isConfirm: true, confirmText: '삭제', isCancel: true, cancelText: '취소', onConfirm: () => { alertRef.current.hideAlert(); deleteCoupon(data._id.$oid) } })
        }
    }

    //쿠폰 상세 확인
    const showCouponInfo = (e, data) => {
        if (e.target.id !== 'delete-icon') {
            setInfo(data);
            modalRef.current.openModal();
        }
    }

    return (
        <div className='commerce-coupon'>
            <p className='header-text'>커머스 쿠폰 관리</p>
            <p className='sub-header-text'>판매중인 쿠폰 ({list.length})</p>
            <p className='warn-soldout'>* 부가세 신고자료 제공시 아직 정산 및 사용이 되지 않은 커머스 쿠폰도 신고자료의 매출에 포함되니 참고 부탁드립니다.</p>

            {
                list.length > 0 ?
                    <Grid container direction={'row'} spacing='17' alignItems="center" columns={16} className='grid'>
                        {
                            list.map((data, i) => (
                                <Grid item lg={8} key={i}>
                                    <div className='coupon-box' id="coupon-info" onClick={(e) => showCouponInfo(e, data)}>
                                        <div className='row' style={{ alignItems: 'flex-start' }}>
                                            <div style={{ position: 'relative' }}>
                                                <img src={"https://cdn.syrupfriends.com/Images/Commerce/" + data.Img[0]} className='coupon-img'></img>
                                                {
                                                    data.Img.length > 1 &&
                                                    <div className='more-img'>+{data.Img.length - 1}</div>
                                                }
                                            </div>
                                            <div style={{ width: '100%' }}>
                                                <div className='row between'>
                                                    <div class="coupon-title ellipsis">
                                                        <span className='coupon-title-concat'>{data.Name}</span>
                                                    </div>
                                                    {
                                                        data.isCheck === 'Pending' &&
                                                        <div className='row'>
                                                            <div className='type-box' style={{ backgroundColor: '#f95f53', color: 'white' }}>
                                                                검수중
                                                            </div>
                                                            {
                                                                data.IssuedCount === 0 &&
                                                                <div id='delete-icon' onClick={(e) => deleteCouponAlert(e, data)} style={{ cursor: 'pointer' }}>
                                                                    <img id='delete-icon' src={require('../../aseets/icons/coupon-delete.svg').default} style={{ width: 24, height: 24, marginRight: 12 }} />
                                                                </div>
                                                            }
                                                        </div>
                                                    }

                                                    {
                                                        data.isCheck === 'Stop' &&
                                                        <div className='row'>
                                                            <div className='type-box' style={{ backgroundColor: '#f95f53', color: 'white', marginRight: 28 }}>
                                                                판매중지
                                                            </div>
                                                            {
                                                                data.IssuedCount === 0 &&
                                                                <div id='delete-icon' onClick={(e) => deleteCouponAlert(e, data)} style={{ cursor: 'pointer' }}>
                                                                    <img id='delete-icon' src={require('../../aseets/icons/coupon-delete.svg').default} style={{ width: 24, height: 24, marginRight: 12 }} />
                                                                </div>
                                                            }
                                                        </div>
                                                    }

                                                    {
                                                        data.isCheck === 'Reject' &&
                                                        <div className='row'>
                                                            <div className='type-box' style={{ backgroundColor: '#f95f53', color: 'white', marginRight: 28 }}>
                                                                반려
                                                            </div>
                                                            <div id='delete-icon' onClick={(e) => deleteCouponAlert(e, data)} style={{ cursor: 'pointer' }}>
                                                                <img id='delete-icon' src={require('../../aseets/icons/coupon-delete.svg').default} style={{ width: 24, height: 24, marginRight: 12 }} />
                                                            </div>
                                                        </div>
                                                    }
                                                    {
                                                        (data.IssuedCount === 0 && data.isCheck === 'Done') &&
                                                        <div id='delete-icon' onClick={(e) => deleteCouponAlert(e, data)} style={{ cursor: 'pointer' }}>
                                                            <img id='delete-icon' src={require('../../aseets/icons/coupon-delete.svg').default} style={{ width: 24, height: 24, marginRight: 24 }} />
                                                        </div>
                                                    }
                                                </div>
                                                <div className='row between'>
                                                    <p className='category-text'>{data.Category}</p>
                                                    {
                                                        data.isCheck === 'Reject' &&
                                                        <p className='reason'>반려사유 : {data.Reason}</p>
                                                    }
                                                </div>
                                                <div className='row'>
                                                    <p className='coupon-price'>{convertCost(data.Price)}원</p>
                                                    <div className='type-box' style={{ backgroundColor: 'transparent', borderColor: '#f95f53', borderWidth: 0.5, borderStyle: 'solid', color: '#f95f53', marginLeft: 8, paddingBottom: 0 }}>
                                                        <p>{data.DiscountRate}% 할인</p>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <p className='info-text'>판매수 : {convertCost(data.IssuedCount)}</p>
                                                    <p className='info-text'>사용수 : {convertCost(data.UsedCount)}</p>

                                                </div>
                                                <div className='row'>
                                                    {
                                                        data.IsLimit &&
                                                        <p className='info-text'>제한 수량 : {convertCost(data.LimitCount)}</p>
                                                    }
                                                    {
                                                        data.IsLimit &&
                                                        <p className='info-text'>남은 수량 : {convertCost(data.StockCount)}</p>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Grid>
                            ))

                        }
                    </Grid>
                    :
                    <div>
                        <p className='empty-list'>생성된 쿠폰이 없습니다.</p>
                    </div>
            }

            <Button
                variant="main"
                style={{ width: 163, paddingBottom: 20, paddingTop: 20, alignSelf: 'center', marginTop: 40 }}
                onClick={() => createModalRef.current.openModal()}
            >
                새 쿠폰 발행하기
            </Button>

            <Modal ref={modalRef} contentContainer={{ width: 500 }}>
                <CommerceCouponInfo info={info} deleteCoupon={deleteCoupon} closeModal={() => modalRef.current.closeModal()} />
            </Modal>

            <Modal ref={createModalRef} contentContainer={{ width: 500 }} isHeader title="커머스 쿠폰 발행">
                <CommerceCouponCreate createCoupon={createCoupon} />
            </Modal>
        </div>
    )
}

export default CommerceCoupon;